import { openBlock as e, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const C = {}, s = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(i, o) {
  return e(), t("svg", s, o[0] || (o[0] = [
    r("path", {
      d: "M2.73219 12.3125V15.6161C2.73219 15.9631 2.80055 16.3068 2.93336 16.6274C3.06618 16.9481 3.26085 17.2394 3.50626 17.4849C3.75168 17.7303 4.04302 17.9249 4.36367 18.0577C4.68431 18.1906 5.02798 18.2589 5.37505 18.2589H14.625C15.326 18.2589 15.9982 17.9805 16.4938 17.4849C16.9895 16.9892 17.2679 16.317 17.2679 15.6161V12.3125M11.9822 12.3125V18.2444M2.73219 13.9643H11.9822M5.41997 9.55071C6.41765 9.55071 7.30301 9.07235 7.85933 8.33235C8.14295 8.71165 8.5111 9.01958 8.93455 9.23169C9.358 9.4438 9.82508 9.55424 10.2987 9.55424C10.7723 9.55424 11.2394 9.4438 11.6628 9.23169C12.0863 9.01958 12.4544 8.71165 12.738 8.33235C13.1222 8.84424 13.6576 9.22231 14.2686 9.41303C14.8795 9.60375 15.5349 9.59744 16.1421 9.39501C16.7492 9.19259 17.2773 8.80429 17.6515 8.28511C18.0257 7.76593 18.2272 7.14217 18.2273 6.50218C18.2273 5.68818 17.6181 3.15896 15.1774 2.1811C11.3928 1.59703 9.2574 1.59175 5.41997 2.1811C2.98062 3.15896 2.37012 5.68818 2.37012 6.50218C2.37047 7.31082 2.69195 8.08622 3.26387 8.6579C3.83579 9.22957 4.61133 9.55071 5.41997 9.55071Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ n(C, [["render", c]]);
export {
  _ as S
};
